import { render, staticRenderFns } from "./StaffBoard.vue?vue&type=template&id=22120e7e&"
import script from "./StaffBoard.vue?vue&type=script&lang=js&"
export * from "./StaffBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports